export enum LayerType {
  Group = 1,
  WMS = 2,
  TMS = 3,
  Tileset = 4,
  GeoJSON = 5,
  ArcgisFeatureServer = 6,
  Terrain = 7,
  PointCloud = 8,
  ArcgisMapServer = 10,
}